import React from 'react'
import { Tooltip } from '@pinchenterprisesnpm/friday-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamation } from '@fortawesome/pro-solid-svg-icons'
import { TooltipIconWrap } from './style'

type TErrorTooltipProps = {
  message: string
}

const ErrorTooltip = (props: TErrorTooltipProps) => {
  const { message } = props
  return (
    <Tooltip text={message} hasArrow>
      <TooltipIconWrap>
        <FontAwesomeIcon icon={faExclamation} size='xs' data-testid='error-tooltip-icon' />
      </TooltipIconWrap>
    </Tooltip>
  )
}

export default ErrorTooltip
